import { observable, makeObservable, action, runInAction } from 'mobx';
import { getEnv, getRoot } from 'mobx-easy';

import UserType from './domain-objects/user-type';
import BaseDomainStore from '../core/base-domain-store';
import { RootStore } from '../root-store-types';
import { RootEnv } from '../root-env';
import { getSharedRootStore } from '../root-store';
import { hasFeatureFlag } from '../other/feature-flags';

const emptyUserType = {
	id: 0,
	title: 'No Active Role'
};

class UserTypeStore extends BaseDomainStore<UserType> {
	isFetched = false;

	constructor() {
		super();

		makeObservable(this, {
			isFetched: observable,
			setIsFetched: action
		});
	}

	fetchAll = async (): Promise<UserType[]> => {
		const { merchantConfigurationsStore } = getRoot<RootStore>().data;
		const { usersStore } = getSharedRootStore().data;
		const enableRouteCostCalculation = hasFeatureFlag(usersStore.currentUser, 'enable_route_cost_calculation');

		if (merchantConfigurationsStore.configuration?.enable_user_types) {
			const { user_types: userTypes }: any = await getEnv<RootEnv>().dashboardSdk.sdk.userTypes.getAll();
			if (!enableRouteCostCalculation) {
				// some old code expects to have empty user role as no active role
				// should be removed after enable_route_cost_calculation rollout
				this.set(new UserType(emptyUserType, this)); // add empty user role as no active role
			}

			runInAction(() => {
				userTypes.forEach(userType => this.set(new UserType(userType, this)));
			});

			this.setIsFetched(true);
			return this.all;
		}
		this.setIsFetched(true);
		return [];
	};

	setIsFetched = (isFetch: boolean) => {
		this.isFetched = isFetch;
	};
}

export default UserTypeStore;
